import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {TabsEnum} from './enums/TabsEnum';
import {HabitudeCuissonEnum} from './enums/HabitudeCuissonEnum';
import {UtilisationCuissonEnum} from './enums/UtilisationCuissonEnum';
import {HabitudeChauffageEnum} from './enums/HabitudeChauffageEnum';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {UsageOccupant} from './models/UsageOccupant';
import {AmpouleEnum} from './enums/AmpouleEnum';
import {HabitudeECSEnum} from './enums/HabitudeECSEnum';
import {Logement} from '../../../models/logement';
import {EnergieEnum} from '../suivi-des-consommations/enums/EnergieEnum';
import {EnergieService} from '../../../services/rt2012/energie.service';
import {Subscription} from 'rxjs';
import {UsageOccupantService} from '../../../services/rt2012/usage-occupant.service';
import {ToastService} from '../../../services/toast.service';

@Component({
    selector: 'app-parametrage-usages',
    templateUrl: './parametrage-usages.component.html',
    styleUrls: ['./parametrage-usages.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParametrageUsagesComponent implements OnInit, OnDestroy {

  TabsEnum = TabsEnum;
  HabitudeChauffageEnum = HabitudeChauffageEnum;
  HabitudeCuissonEnum = HabitudeCuissonEnum;
  UtilisationCuissonEnum = UtilisationCuissonEnum;
  AmpouleEnum = AmpouleEnum;
  HabitudeECSEnum = HabitudeECSEnum;

  form: UntypedFormGroup;
  activeTab: TabsEnum = null;

  @Input() logement: Logement;
  @Output() usageOccupantUpdated = new EventEmitter();

  usageOccupant: UsageOccupant = null;

  private formValueChangeSubscription: Subscription;


  constructor(private energieService: EnergieService,
              private usageOccupantService: UsageOccupantService,
              private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
    this.usageOccupant = this.logement.usageOccupant;
    if (this.usageOccupant === null) {
      this.usageOccupant = new UsageOccupant();
      this.logement.usageOccupant = this.usageOccupant;
    }

    this.form = new UntypedFormGroup({

      //region Informations Générales
      nbOccupants: new UntypedFormControl(this.usageOccupant.nbOccupants),
      habitudeChauffage: new UntypedFormControl(this.usageOccupant.habitudeChauffage),
      //endregion

      //region Personnalisation avancée
      //region Cuisson
      cuissonPlaqueGazFixe: new UntypedFormControl(this.usageOccupant.cuissonPlaqueGazFixe),
      cuissonPlaqueElecPort: new UntypedFormControl(this.usageOccupant.cuissonPlaqueElecPort),
      cuissonPlaqueElecFixe: new UntypedFormControl(this.usageOccupant.cuissonPlaqueElecFixe),

      cuissonFourElec: new UntypedFormControl(this.usageOccupant.cuissonFourElec),
      cuissonFourGaz: new UntypedFormControl(this.usageOccupant.cuissonFourGaz),
      cuissonFourMicroondes: new UntypedFormControl(this.usageOccupant.cuissonFourMicroondes),

      habitudesCuisson: new UntypedFormControl(this.usageOccupant.habitudesCuisson),
      utilisationCuisson: new UntypedFormControl(this.usageOccupant.utilisationCuisson),
      //endregion

      //region Equipements Domestiques
      combineNb: new UntypedFormControl(this.usageOccupant.combineNb),
      classeEnerCombi: new UntypedFormControl(this.usageOccupant.classeEnerCombi),

      refrigerateurNb: new UntypedFormControl(this.usageOccupant.refrigerateurNb),
      classeEnerRefrigerateur: new UntypedFormControl(this.usageOccupant.classeEnerRefrigerateur),

      congelateurNb: new UntypedFormControl(this.usageOccupant.congelateurNb),
      classeEnerCongelateur: new UntypedFormControl(this.usageOccupant.classeEnerCongelateur),

      laveLingeNb: new UntypedFormControl(this.usageOccupant.laveLingeNb),
      classeEnerLaveLinge: new UntypedFormControl(this.usageOccupant.classeEnerLaveLinge),
      laveLingeEcs: new UntypedFormControl(this.usageOccupant.laveLingeEcs),

      secheLingeNb: new UntypedFormControl(this.usageOccupant.secheLingeNb),
      classeEnerSecheLinge: new UntypedFormControl(this.usageOccupant.classeEnerSecheLinge),

      laveVaisselleNb: new UntypedFormControl(this.usageOccupant.laveVaisselleNb),
      classeEnerLaveVaisselle: new UntypedFormControl(this.usageOccupant.classeEnerLaveVaisselle),
      laveVaisselleEcs: new UntypedFormControl(this.usageOccupant.laveVaisselleEcs),

      tvLcdNb: new UntypedFormControl(this.usageOccupant.tvLcdNb),
      tvPlasmaNb: new UntypedFormControl(this.usageOccupant.tvPlasmaNb),
      modemNb: new UntypedFormControl(this.usageOccupant.modemNb),
      ferNb: new UntypedFormControl(this.usageOccupant.ferNb),
      ordinateurNb: new UntypedFormControl(this.usageOccupant.ordinateurNb),
      imprimanteNb: new UntypedFormControl(this.usageOccupant.imprimanteNb),
      aquariumNb: new UntypedFormControl(this.usageOccupant.aquariumNb),
      aspirateurNb: new UntypedFormControl(this.usageOccupant.aspirateurNb),
      //endregion

      //region Eclairage
      lampadairesNb: new UntypedFormControl(this.usageOccupant.lampadairesNb),
      lampadairesAmpoule: new UntypedFormControl(this.usageOccupant.lampadairesAmpoule),

      lampesNb: new UntypedFormControl(this.usageOccupant.lampesNb),
      lampesAmpoule: new UntypedFormControl(this.usageOccupant.lampesAmpoule),

      plafonniersNb: new UntypedFormControl(this.usageOccupant.plafonniersNb),
      plafonniersAmpoule: new UntypedFormControl(this.usageOccupant.plafonniersAmpoule),

      appliquesNb: new UntypedFormControl(this.usageOccupant.appliquesNb),
      appliquesAmpoule: new UntypedFormControl(this.usageOccupant.appliquesAmpoule),

      spotsNb: new UntypedFormControl(this.usageOccupant.spotsNb),
      spotsAmpoule: new UntypedFormControl(this.usageOccupant.spotsAmpoule),

      tubesNb: new UntypedFormControl(this.usageOccupant.tubesNb),
      //endregion

      //region Salle d'eau
      habitudesEcs: new UntypedFormControl(this.usageOccupant.habitudesEcs),
      baignoireNb: new UntypedFormControl(this.usageOccupant.baignoireNb), // non utilisé dans l'algo ?
      doucheNb: new UntypedFormControl(this.usageOccupant.doucheNb), // non utilisé dans l'algo ?
      //endregion

      //region Energie
      prixElectricite: new UntypedFormControl(this.usageOccupant.prixElectricite),
      prixGaz: new UntypedFormControl(this.usageOccupant.prixGaz),
      coefConversionGaz: new UntypedFormControl(this.usageOccupant.coefConversionGaz),
      coefConversionFioul: new UntypedFormControl(this.usageOccupant.coefConversionFioul),
      //endregion
      //endregion
    });

    this.formValueChangeSubscription = this.form.valueChanges.subscribe(value => {
      Object.assign(this.usageOccupant, this.form.value);
    });
  }

  ngOnDestroy() {
    this.formValueChangeSubscription.unsubscribe();
  }

  switchTab(tab: TabsEnum) {
    this.activeTab = tab;
  }

  isActiveTab(tab: TabsEnum): boolean {
    return this.activeTab === tab;
  }

  submit() {
    this.usageOccupantService.save(this.usageOccupant, this.logement).then((usageOccupant) => {
      this.usageOccupantUpdated.emit(usageOccupant);
      this.toastService.showSuccess('Votre personnalisation a bien été mise à jour.');
    }).catch(() => {
      this.toastService.showError('Une erreur est survenue lors de la mise à jour de votre personnalisation');
    });
  }

  hasEnergiesToTune(): boolean {
    return this.hasFioul() || this.hasGaz();
  }

  hasFioul(): boolean {
    return this.energieService.getEnergiesAvailables(this.logement, this.usageOccupant).find(value => value === EnergieEnum.FIOUL) != null;
  }

  hasGaz(): boolean {
    return this.energieService.getEnergiesAvailables(this.logement, this.usageOccupant).find(value => value === EnergieEnum.GAZ) != null;
  }
}
